import { Badge, Button, Card, IconTile } from "@design";
import { LayoutDashboard, MessageSquare, Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useAreaCrumbs } from "@/components/areaCrumbs";
import { PageBreadcrumbs } from "@/components/PageBreadcrumbs";
import { Text } from "@/components/Text";

/**
 * /build/apps/new — micro-apps are created by chatting (an HTML artifact
 * published via /micro-apps/publish), so there's no standalone form. This
 * page explains that and opens the Build with AI chat for micro-apps.
 */
export function NewMicroAppPage() {
  const { t } = useTranslation("microApps");
  const areas = useAreaCrumbs();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col">
      <PageBreadcrumbs trail={[areas.build, { label: t("title"), to: "/build/apps" }]} current={t("create.title")} />
      <div className="mx-auto flex w-full max-w-2xl flex-col gap-6 px-4 py-6 md:px-8">
        <Card size="md">
          <div className="flex flex-col items-center gap-3 py-6 text-center">
            <IconTile variant="brand">
              <MessageSquare size={20} aria-hidden />
            </IconTile>
            <Badge variant="brand">{t("builtInChat")}</Badge>
            <Text variant="h3">{t("create.title")}</Text>
            <Text variant="body-sm" tone="secondary" className="max-w-md">
              {t("create.body")}
            </Text>
            <Button
              variant="primary"
              leadingIcon={<Sparkles size={14} />}
              onClick={() => navigate("/build/with-ai?entity=micro_app")}
            >
              {t("create.openBuilder")}
            </Button>
          </div>
        </Card>
        <div className="flex items-center justify-center gap-2 text-content-tertiary">
          <LayoutDashboard size={16} aria-hidden />
          <Text variant="caption" tone="tertiary">
            {t("subtitle")}
          </Text>
        </div>
      </div>
    </div>
  );
}
